import React, { PureComponent } from 'react';
import { SocialButtons, ContactsList } from '../index';

class MemberContact extends PureComponent {

  render() {
    const { name, position, contacts, follow } = this.props;
    return (
      <div className="member-contact">
        <img src="http://lorempixel.com/228/228/people?0" className="img-responsive img-circle" alt=""/>
        <h4>{name}</h4>
        <p className="text-muted">{position}</p>
        <SocialButtons follow={follow}/>
        <ContactsList contacts={contacts}/>
      </div>
    );
  }
}

MemberContact.propTypes = {};
MemberContact.defaultProps = {};

export default MemberContact;



// WEBPACK FOOTER //
// ./src/components/MemberContact/MemberContact.js